<template>
    <div>
        <ThemesTab
            :titleName="tabData"
            class="mb-3 mt-5"
            :activeTab="activeTab"
            @changeActive="changeActive"
        />
        <!-- 精選內容 文章資料 -->
        <ArticleDisplay
            display="card"
            :contentPage="tabData[activeTab].name"
            :articleRes="tabData[activeTab].article"
            :currentPage="1"
            :loading="loading"
        />
        <div class="btnBlock mx-auto mb-2">
            <router-link
                v-if="tabData[activeTab].name==='熱門推薦'"
                :to="{ name: 'ranking', params: { page: 1, sort: 'hot', category: '' } }"
            >
                <button
                    type="button"
                    class="btn btn-sec search__btn d-inline-block rounded-pill pt-2 w-100"
                    :data-ga-element="`${gaData}${tabData[activeTab].name}|觀看更多`"
                >
                    觀看更多
                </button>
            </router-link>
            <router-link
                v-if="tabData[activeTab].name==='最新文章'"
                :to="{ name: 'ranking', params: { page: 1, sort: 'new', category: '' } }"
            >
                <button
                    type="button"
                    class="btn btn-sec search__btn d-inline-block rounded-pill pt-2 w-100"
                    :data-ga-element="`${gaData}${tabData[activeTab].name}|觀看更多`"
                >
                    觀看更多
                </button>
            </router-link>
        </div>
    </div>
</template>
<script>
import ThemesTab from '@/components/ThemesTab.vue';
import ArticleDisplay from '../itemList/ArticleDisplay.vue';
export default {
    name: 'HomeTabArticleList',
    components: {
        ArticleDisplay,
        ThemesTab
    },
    props: {
        // tab1Article
        articleList1: {
            type: [Array, null],
            default: null,
        },
        // tab2Article
        articleList2: {
            type: [Array, null],
            default: null,
        },
        tabData: {
            type: [Array, null],
            default: null,
        },
        gaData: {
            type: String,
            default: '健康及保險知識+'
        }
    },
    data() {
        return {
            loading: false,
            category: '',
            activeTab: 0,
        };
    },
    methods: {
        changeActive(index) {
            console.log(index);
            this.activeTab = index;
        },
    },
};
</script>
<style lang="scss" scoped >
.btnBlock {
    width: 100%;
    max-width: 24rem;
    @include media-breakpoint-up(md) {
        width: 50%;
    }
}
</style>
